import Vue from "vue";

Vue.component("trade-concerns-number-of-times-raised", {
	props: ["domainIds", "memberType", "countryId"],
	data() {
		return {
			items: []
		};
	},
	computed: {
		language() {
			return window.languageEnumToString;
		},
		tradeConcernsDetailsUrl() {
			return window.urls.tradeConcernsDetails;
		},
	},
	methods: {
		getNumberOfTimeRaised: function () {
			let domainIds = this.domainIds && this.domainIds.length > 0 ? this.domainIds : [1,2];
			this.$services.tradeConcerns.getMemberProfileNumberOfTimesRaised({
				language: this.language,
				searchParameterMemberCode: this.countryId,
				searchParameterDomainIds: domainIds,
				memberProfileType: this.memberType
			})
				.then((data) => {
					this.items = data;
				});
		},
	},
	mounted() {
		this.getNumberOfTimeRaised();
	},
	watch: {
		domainIds: function () {
			this.getNumberOfTimeRaised();
		}
	},
	template: `
		 <b-table :data="items" detail-key="id">
			<b-table-column field="imsId" width="20%" v-slot="props">
				{{ props.row.area }} {{ props.row.imsId }}
			</b-table-column>
			<b-table-column field="titleSubs" width="60%" v-slot="props">
				<p :title="props.row.titleSubs" class="profile-number-of-time-raised-title">
					<a class="symbol-link" v-bind:href="tradeConcernsDetailsUrl + '?imsId=' + props.row.imsId + '&domainId=' + props.row.area" target="_blank">
						{{ props.row.titleSubs }}
					</a>
				</p>
			</b-table-column>
			<b-table-column field="numberOfTimesRaised" v-slot="props" width="20%">
				{{ props.row.numberOfTimesRaised }}
			</b-table-column>
		</b-table>
	`,
});